import { Entity } from '../entity.js';
import { blinkToward } from '../combat/abilityArea.js';

function pushSkillshot(bucket, caster, tx, ty, gameTime, opts) {
  const angle = Math.atan2(ty - caster.y, tx - caster.x);
  bucket.push({
    id: `${opts.idPrefix}-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * opts.speed,
    vy: Math.sin(angle) * opts.speed,
    range: opts.range,
    traveled: 0,
    damage: opts.damage,
    damageType: opts.damageType || 'physical',
    radius: opts.radius || 16
  });
}

export function createEzreal(id = 'ezreal-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 548,
    maxMp: 360,
    ad: 61,
    ap: 0,
    armor: 26,
    mr: 30,
    ms: 325,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Ezreal',
    radius: 20
  });
}

export function castEzrealQ(caster, tx, ty, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 28) return false;
  caster.mp -= 28;
  pushSkillshot(projectiles, caster, tx, ty, gameTime, {
    idPrefix: 'ezreal-q',
    speed: 2000,
    range: 1200,
    damage: 35 + (caster.ad || 0) * 1.1,
    radius: 60
  });
  return true;
}

export function castEzrealW(caster, tx, ty, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 50) return false;
  caster.mp -= 50;
  pushSkillshot(projectiles, caster, tx, ty, gameTime, {
    idPrefix: 'ezreal-w',
    speed: 1700,
    range: 1200,
    damage: 80 + (caster.ap || 0) * 0.7,
    damageType: 'magic',
    radius: 80
  });
  return true;
}

export function castEzrealE(caster, tx, ty) {
  if (!caster || caster.isDead || caster.mp < 70) return false;
  caster.mp -= 70;
  blinkToward(caster, tx, ty, 475);
  return true;
}

export function castEzrealR(caster, tx, ty, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 100) return false;
  caster.mp -= 100;
  pushSkillshot(projectiles, caster, tx, ty, gameTime, {
    idPrefix: 'ezreal-r',
    speed: 2000,
    range: 5000,
    damage: 250 + (caster.ad || 0) * 1.0,
    radius: 160
  });
  return true;
}
